import { render } from "./ServicesDatatableActionsServiceCategory.vue?vue&type=template&id=64a6b914"
import script from "./ServicesDatatableActionsServiceCategory.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableActionsServiceCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__